export default function getHelpAndSupport() {
    
    return {
        sunnyInitialMessage: `Hi, I’m Sunny. I’m here to help you with any questions about your SolarZero system. You can ask me about your energy usage, how to optimise your solar performance, troubleshooting issues, and more. Let’s make your solar experience as smooth and efficient as possible. What would you like to know today?`,
        helpAndSupport: {
            faqs: [
                'How can I set up my direct debit details?', 
                'When is the best time to charge my EV?',
                'How will I know how much power the battery has got stored?',
                'How does the Refer-a-Friend process work?',
                'How do I schedule the hot water savings mode?',
            ]
            
        },
        contactUs: {
            number: '0800 11 66 55',
            emailAddress: 'customercare@solarzero.co.nz',
            hoursList: [
                'Monday to Thursday from 8.30am to 5.30pm.', 
                'Fridays from 8.30am to 5.00pm.', 
                'Closed on weekends and holidays'
            ]
        },
        referFriend: {
            prompt: 'Help a friend switch to solar and get rewarded',
            steps: [
                {
                    number: 1,
                    title: 'Share',
                    description: 'Get your unique referral code and share it with your friends and family.'
                },
                // {
                //     number: 2,
                //     title: 'Track',
                //     description: 'Check their progress in our app to see when they’ve had a solar system installed.'
                // },
                {
                    number: 2,
                    title: 'Earn',
                    description: 'Receive $1,000 for every person you refer once they’ve had their solar system activated.'
                }
            ]
        },
        debitForm: {
            formDescription: 'Use this form to add or update Direct Debit bank details on your account.',
            infoText: 'Setting up a new direct debit will override any existing direct debit authority on this account. If you wish to cancel existing direct debit authority, please contact us on ',
            solarZeroPhoneNumber: '0800 11 66 55',
        },

    }
}